import React from 'react';
import './ImagePreviewModal.css';

interface ImagePreviewModalProps {
  fileName: string;
  base64Content?: string;
  imageUrl?: string;
  mimeType?: string;
  onClose: () => void;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  fileName,
  base64Content,
  imageUrl,
  mimeType,
  onClose,
}) => {
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="image-preview-overlay" onClick={handleOverlayClick}>
      <div className="image-preview-content">
        <div className="image-preview-header">
          <h3>{fileName}</h3>
          <button className="image-preview-close" onClick={onClose}>
            <span className="material-icons">close</span>
          </button>
        </div>
        <div className="image-preview-body">
          <img
            src={base64Content ? `data:${mimeType};base64,${base64Content}` : imageUrl}
            alt={fileName}
          />
        </div>
      </div>
    </div>
  );
};

export default ImagePreviewModal;
